import io from 'socket.io-client/dist/socket.io.js'
// import { useFalconStore } from '@/stores/global/falcon/useFalcon'
import store from '@/store'

export default class Falcon {
  constructor(store) {
    this.store = store
    this.project_id = process.env.VUE_APP_PROJECT_ID

    // this.project_id = import.meta.env.VITE_PROJECT_ID
    this.socket = null
    this.connected = false
    this.is_connection_error = false
  }

  initialize(client_id, username) {
    console.log('[Falcon] Initializing service...')
    // this.socket = io(import.meta.env.VITE_FALCON_ENDPOINT)
    this.socket = io(process.env.VUE_APP_FALCON_ENDPOINT)

    this.socket.on('connect', () => {
      console.log(`[Falcon][trace] Server connected - ${this.socket.id}`)

      this.connected = true
      this.is_connection_error = false

      this.socket.emit('subscribe', { project_id: this.project_id, client_id, username })
    })

    this.socket.on('connect_error', (error) => {
      console.error(`[Falcon][error] Server connection error - ${error.message}`)

      this.connected = false
      this.is_connection_error = true
    })

    this.socket.on('disconnect', () => {
      console.log(`[Falcon][trace] Server disconnected`)

      this.connected = false
      this.is_connection_error = false
    })

    this.socket.on('event', (event) => {
      // console.log(`[Falcon][trace] Received Event: ${event.name}`)
      // const falconStore = useFalconStore()
      // falconStore.falconEventHandler(event)
      store.dispatch('falconEventHandler', event)
    })
  }

  reset() {
    console.log('[Falcon] Disconnected from server...')
    if (this.socket) this.socket.disconnect()
    this.socket = null
  }
}
